// extracted by mini-css-extract-plugin
module.exports = {"section":"Sect3_Comp2_section__3vfPT","content":"Sect3_Comp2_content__2xCK1","lightbox":"Sect3_Comp2_lightbox__34Poa"};